import { ReactNode } from 'react';
import styled from 'styled-components';

import Column from 'packages/kakapo-ui-kit/components/grid/Column';
import HorizontalRule from 'packages/kakapo-ui-kit/components/common/HorizontalRule';

interface IProps {
	children: ReactNode;
	dark?: boolean;
}

const Element = styled.div<{ dark?: boolean }>`
	background-color: ${(props) => (props.dark ? props.theme.colors.lightBlue : 'transparent')};
	color: ${(props) => (props.dark ? props.theme.colors.slateBlue : 'auto')};
`;

export default function ModalFooter({ children, dark }: IProps) {
	return (
		<Element dark={dark}>
			<HorizontalRule />

			<Column py={3}>{children}</Column>
		</Element>
	);
}
